class YoutubePlayer {
    constructor(video_id){
        //console.log('Player:Youtube');
        this.video_id = video_id;
        this.options = {
            modestbranding:0, 
            showinfo:0, 
            playsinline:1, 
            autoplay:1, 
            controls:0, 
            disablekb:0, 
            loop:1, 
            rel:0, 
            iv_load_policy:3
        };
        this.events = {
            mute:false,
            play:false,
            stop:false
        };
        this.is_ready = false;
    }

    ready (){
        this.is_ready = true;
        Object.keys(this.events).map((event) => {
            //console.log('Event:', event, this.events[event]);
            if(this.events[event] === true){
                this[event]();
            }
        });
    }

    showTitle(status){
        this.options.showinfo = status === false ? 0 : 1;
        return this;
    }

    mute(){
        if(!this.is_ready){
            this.events.mute = true;
            return this;
        }
        //console.log('Youtube:mute');
        this.player.mute();
        return this;
    }

    play(){
        if(!this.is_ready){
            this.events.play = true;
            return this;
        }
        //console.log('Youtube:play');
        this.player.playVideo();
        return this;
    }

    stop(){
        if(!this.is_ready){
            this.events.play = true;
            return this;
        }
        //console.log('Youtube:stop');
        this.player.stopVideo();
        document.getElementById(this.video_id).childNodes[0].remove();
        return this;
    }

    source(source){
        let content = document.getElementById(this.video_id);
        let iframe = document.createElement('iframe');
        iframe.id = this.video_id + '_iframe';
        iframe.src = source  + '?enablejsapi=1';
        iframe.setAttribute('width', '100%');
        iframe.setAttribute('height', '100%');
        iframe.setAttribute('frameborder', 0);
        
        content.appendChild(iframe);
        content.style.width = '100%';
        content.style.height = '100%';

        //console.log('Youtube:init');
        this.player = new YT.Player(this.video_id + '_iframe', {
            height: '100%',
            width: '100%',
            playerVars: this.options,
            events: {
                onReady: (event) => {
                    this.ready();
                },
                onStateChange: function onPlayerStateChange(event) {
                    if (event.data == YT.PlayerState.ENDED) {
                        event.target.playVideo();
                    }      
                }
            }
        });
        return this;
    }
}

export default YoutubePlayer;